import React from 'react';
import styles from './Emoji.module.scss';

const Emoji = ({ unicode }) => {
  return (
    <span className={styles.emoji} role="img" aria-label={unicode}>
      {unicode ? String.fromCodePoint(unicode) : null}
    </span>
  );
};

export default Emoji;
